<template>
    <div class="service-header tw-grid tw-items-start">
        <!-- Artwork -->
        <div class="service-header__artwork tw-rounded tw-overflow-hidden tw-self-start">
            <BaseArtwork :src="service.image(600)"
                         :image-size="600" active-transparent>
            </BaseArtwork>
        </div>

        <!-- Details -->
        <div class="service-header__details">
            <!-- Title -->
            <div class="tw-text-3xl tw-font-medium tw-text-infinity-primary-text tw-flex tw-items-center tw-mb-5">
                <span>{{ service.title }}</span>
                <share-button :item="service" class="tw-text-infinity-tertiary-text tw-ml-4"
                              style="font-size: 1.15rem;" />
            </div>

            <!-- Description -->
            <ServiceHeaderDescription :text="service.description" class="tw-pb-2" />
        </div>

        <!-- Chips -->
        <div class="service-header__chips tw-grid tw-gap-3">
            <div class="tw-flex tw-items-center tw-space-x-2 tw-text-infinity-secondary-text">
                <font-awesome-icon :icon="['far', 'repeat']" class="tw-text-infinity-tertiary-text"></font-awesome-icon>
                <span>{{service.revisions}} Revisions</span>
            </div>
            <div class="tw-flex tw-items-center tw-space-x-2 tw-text-infinity-secondary-text">
                <font-awesome-icon :icon="['far', 'clock']" class="tw-text-infinity-tertiary-text"></font-awesome-icon>
                <span>{{service.deliveryLabel}}</span>
            </div>
            <div v-if="service.samples_link" class="tw-flex tw-items-center tw-space-x-2 tw-text-infinity-secondary-text">
                <font-awesome-icon :icon="['far', 'download']" class="tw-text-infinity-tertiary-text"></font-awesome-icon>
                <a :href="service.samples_link" class="tw-underline" target="_blank">Download work samples </a>
            </div>
            <div v-if="service.agreement" class="tw-cursor-pointer hover:tw-underline tw-underline tw-flex tw-items-center tw-space-x-2 tw-text-infinity-secondary-text" @click="openLicenseAgreement">
                <font-awesome-icon icon="list" class="tw-text-infinity-tertiary-text"></font-awesome-icon>
                <span>License Agreements</span>
            </div>
            <div v-if="service.tagsStringFormatted.length" class="tw-flex tw-items-center tw-space-x-2 tw-text-infinity-secondary-text">
                <font-awesome-icon :icon="['far', 'tags']" class="tw-text-infinity-tertiary-text"></font-awesome-icon>
                <span>
                    {{ service.tagsStringFormatted}}
                </span>
            </div>
        </div>
        <div class="service-header__buy tw-flex tw-space-x-4">
            <buy-button variant="boxed-big" :item="service" />
        </div>
    </div>
</template>
<script>
import BaseArtwork from "../../base/base-artwork";
import BasePlay from "../../base/base-play";
import Service from "../../../models/service";
import ShareButton from "../../shared/share-button";
import ServiceHeaderDescription from "./service-header-description";
import ServiceHeaderChips from "./service-header-chips";
import BuyButton from "../../shared/buy-button";

export default {
    components: {
        BuyButton,
        ServiceHeaderDescription,
        ServiceHeaderChips,
        ShareButton, BasePlay, BaseArtwork
    },
    props: {
        service: {
            type: Service
        }
    },
    methods: {
        openLicenseAgreement() {
            this.$store.commit('modalLicense', {modalLicense : this.service.license});
            $('#license-terms').modal('show')
        }
    }
};
</script>
<style lang="scss" scoped>
.service-header {
    @apply tw-gap-6;
    grid-template-columns: 1fr;
    grid-template-areas: 'artwork' 'details' 'chips' 'buy';

    &__artwork {
        grid-area: artwork;
    }

    &__details {
        grid-area: details;
    }

    &__chips {
        grid-area: chips;
    }

    &__video {
        grid-area: video;
    }

    &__buy {
        grid-area: buy;
    }

    @screen sm {
        grid-template-columns: minmax(30%, 200px) 1fr;
        grid-template-areas: 'artwork details' 'chips chips' 'buy buy';
    }

    @screen md {
        grid-template-areas: 'artwork details' 'artwork chips' 'artwork buy';
    }

    @screen lg {
        grid-template-columns: minmax(40%, 370px) 1fr;
        grid-template-rows: auto 1fr auto;
    }
}
</style>
